// 定数定義集

export const PUBLIC_PATH = process.env.VUE_APP_PUBLIC_PATH;

export const MOMENT_DEFAULT_FORMAT = 'YYYY/MM/DD HH:mm:ss.SSS';

export const ADMIN_STORAGE_KEY = {
  FIRST_VIEWED_MANABI_OVERVIEW: 'MS_ADMIN_FIRST_VIEWED_MANABI_OVERVIEW',
};

export const USER_STORAGE_KEY = {
  ROOM_ID: 'MS_USER_ROOM',
  ROOM_TYPE: 'MS_USER_ROOM_TYPE',
  STUDY_SECTION_NO: 'MS_USER_STUDY_SECTION_NO',
  IS_JAPANESE_FONT_LARGE: 'MS_USER_IS_JAPANESE_FONT_LARGE',
};

export const FLAG = {
  OFF: '0',
  ON: '1',
};

export const ROOM = {
  ID: {
    DEMO: 'demo',
  }
};
